import { ReadonlyURLSearchParams } from 'next/navigation';
import setAlertValue from '@/components/Alert';
import GlobalContext from '@/context/global-context';
import {
  CANDIDATES_ME_ROUTER_PATH,
  CULTURAL_RESULT_ROUTER_PATH,
  HOME_PAGE_ROUTER_PATH,
  JOB_DETAIL_PAGE_ROUTER_PATH,
  RESUME_EVALUATION_LOADING_ROUTER_PATH,
  RESUME_EVALUATION_ME_ROUTER_PATH,
  RESUME_EVALUATION_ROUTER_PATH,
} from '@/constants/router-path';
import {
  QUERY_REDIRECT,
  QUERY_TARGET,
  QUERY_CREATE,
  QUERY_VALUE,
} from '@/constants/auth';
import { updateJobSeekerData } from '@/utils/culture-preference';
import { isValidUUID } from '@/utils/common-utils';
import { getDBFile } from '@/utils/storage';
import {
  createJobSeekerResume,
  getJobSeekerResumes,
  saveEvaluationResume,
  uploadEvaluationResume,
} from '@/api/tanzhi';

export const baseLogin = async (
  searchParams: URLSearchParams | ReadonlyURLSearchParams | null,
) => {
  const redirectParam = searchParams?.get(QUERY_REDIRECT);
  const targetParam = searchParams?.get(QUERY_TARGET);
  const createParm = searchParams?.get(QUERY_CREATE);
  const valParm = searchParams?.get(QUERY_VALUE);

  let redirectRoute =
    !redirectParam || redirectParam === HOME_PAGE_ROUTER_PATH
      ? undefined
      : redirectParam;

  const targetRoute =
    redirectRoute === CANDIDATES_ME_ROUTER_PATH ||
    redirectRoute?.includes(JOB_DETAIL_PAGE_ROUTER_PATH)
      ? targetParam
      : undefined;
  if (redirectRoute === CULTURAL_RESULT_ROUTER_PATH) {
    try {
      await updateJobSeekerData();
    } catch {
      setAlertValue({
        msg: `文化偏好结果保存失败，请重试`,
      });
    }
  } else if (
    redirectRoute === CANDIDATES_ME_ROUTER_PATH &&
    createParm === 'resume'
  ) {
    try {
      const res = await createJobSeekerResume();
      setAlertValue({
        msg: '简历创建成功，跳转中...',
        severity: 'success',
      });
      redirectRoute = CANDIDATES_ME_ROUTER_PATH + res.data.id;
    } catch {
      setAlertValue({
        msg: `简历创建失败，请重试`,
      });
    }
  } else if (
    redirectRoute === CANDIDATES_ME_ROUTER_PATH &&
    valParm?.includes('resume-advice')
  ) {
    try {
      const response = await getJobSeekerResumes();
      const data = response.data;
      if (data && data.length > 0) {
        redirectRoute = CANDIDATES_ME_ROUTER_PATH + data[data.length - 1].id;
      } else {
        const res = await createJobSeekerResume();
        redirectRoute = CANDIDATES_ME_ROUTER_PATH + res.data.id;
      }
    } catch {
      setAlertValue({
        msg: `获取简历失败，请重试`,
      });
    }
  } else if (
    redirectRoute?.startsWith(RESUME_EVALUATION_ME_ROUTER_PATH) &&
    createParm === 'evaluation'
  ) {
    const id = sessionStorage.getItem(QUERY_VALUE);
    if (id && isValidUUID(id)) {
      try {
        const res = await saveEvaluationResume(id);
        if (res.status === 200) {
          sessionStorage.removeItem(QUERY_VALUE);
          setAlertValue({
            msg: '诊断报告保存成功，跳转中...',
            severity: 'success',
          });
        } else {
          setAlertValue({
            msg: res.data?.detail || '诊断报告保存失败，请重试',
          });
        }
      } catch {
        setAlertValue({
          msg: '诊断报告保存失败，请重试',
        });
      }
    }
  } else if (
    redirectRoute === RESUME_EVALUATION_ROUTER_PATH &&
    createParm === 'evaluation'
  ) {
    const resumeFile = await getDBFile('resume_file');
    const expectJobTitle = await getDBFile('expect_job_title');
    if (resumeFile && expectJobTitle) {
      try {
        const res = await uploadEvaluationResume(expectJobTitle, resumeFile);
        if (res.status === 200) {
          const { id } = res.data;
          redirectRoute = `${RESUME_EVALUATION_LOADING_ROUTER_PATH}?id=${id}`;
        } else {
          setAlertValue({
            msg: res.data?.detail || '诊断简历失败，请重试！',
          });
        }
      } catch {
        setAlertValue({
          msg: '诊断简历失败，请重试！',
        });
      }
    }
  }
  const url = new URL(
    redirectRoute || HOME_PAGE_ROUTER_PATH,
    window.location.origin,
  );
  if (targetRoute) {
    url.searchParams.set(QUERY_REDIRECT, targetRoute);
  } else if (valParm) {
    url.searchParams.set(QUERY_VALUE, valParm);
  }
  sessionStorage.setItem(
    'before_login_referer',
    GlobalContext.getContext('referer') || '',
  );
  window.location.replace(url.toString());
};
